export const ID_UPLOAD_LANGUAGE_STORAGE_KEY = "medistart.idupload.language";
export const ID_UPLOAD_LANGUAGE_WAIT_MESSAGE =
  "Please wait until the upload is finished before changing language.";

const SUPPORTED_LANGUAGES = new Set(["en", "it"]);

export function normalizeIdUploadLanguage(value) {
  const language = String(value || "").trim().toLowerCase().split(/[-_]/)[0];
  return SUPPORTED_LANGUAGES.has(language) ? language : "en";
}

export function getPreferredIdUploadLanguage() {
  try {
    const stored = window.localStorage.getItem(ID_UPLOAD_LANGUAGE_STORAGE_KEY);
    if (stored) return normalizeIdUploadLanguage(stored);
  } catch {
    // Fall through to the browser locale if storage is blocked.
  }

  const browserLanguage =
    typeof navigator !== "undefined"
      ? navigator.language || (Array.isArray(navigator.languages) ? navigator.languages[0] : "en")
      : "en";
  return normalizeIdUploadLanguage(browserLanguage);
}

export function persistIdUploadLanguage(value) {
  const language = normalizeIdUploadLanguage(value);
  try {
    window.localStorage.setItem(ID_UPLOAD_LANGUAGE_STORAGE_KEY, language);
  } catch {
    // The current selection can still be applied when persistence is blocked.
  }
  return language;
}
